import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import moment from "moment";

import { ReactComponent as RefreshIcon } from "assets/images/iconsV2/refresh-blue.svg";
import { useGetTrackingReferences } from "api/queries/shipments/useGetTrackingReferences";
import Button from "components/v2/Button/Button";

export default function TruckUtils() {
  const intl = useIntl();
  const { id } = useParams();

  const {
    data: trackingReferencesData,
    refetch,
    isFetching,
  } = useGetTrackingReferences(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const firstFourTruckReferences =
    trackingReferencesData?.references
      ?.filter((ref: any) => ref.type === "truck")
      ?.filter((ref: any) => ref.truck_tracking_info?.locations?.length > 0)
      ?.slice(0, 4) || [];

  if (firstFourTruckReferences.length === 0) return null;

  const updates = firstFourTruckReferences.map((ref: any) => ref.truck_tracking_info?.location_last_updated).filter(Boolean);
  const latestUpdate = updates.length > 0 ? moment.max(updates.map((date: string) => moment(date))) : null;

  return (
    <div className="d-flex justify-content-between align-items-center mt-md">
      {latestUpdate && (
        <div className="text-xs text-tertiary">
          {intl.formatMessage({
            id: "general.lastUpdated",
            defaultMessage: "Last updated",
          })}{" "}
          {latestUpdate.format("DD MMM YYYY, HH:mm")}
        </div>
      )}
      <Button
        label={intl.formatMessage({
          id: "general.refresh",
          defaultMessage: "Refresh",
        })}
        variant="link-color"
        iconLeft={<RefreshIcon />}
        onClick={() => refetch()}
        disabled={isFetching}
      />
    </div>
  );
}
